module.exports = __webpack_public_path__ + "static/media/pn.93f1c75b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pn.png
// module id = 1959
// module chunks = 0